import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/JsonComponent.types';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { CashFundComponentGrabber } from './CashFundComponentSidebar';
import { CASH_FUND_COMPONENT_SCHEMA_URL, CASH_FUND_COMPONENT_TYPE } from '@shared/websiteCustomJsonComponents/CashFundComponent/CashFundComponent.constants';

// Lazy load view components
const CashFundComponentAdd = loadable(() => import(/* webpackChunkName: "content/websiteEditorCashFundComponentAdd" */ './CashFundComponentSidebar'), 'CashFundComponentAdd');

const CashFundComponentEdit = loadable(() => import(/* webpackChunkName: "content/websiteEditorCashFundComponentEdit" */ './CashFundComponentEdit'), 'CashFundComponentEdit');

export const CashFundComponentConfig: AdminJsonComponentConfig = {
  schemaUrl: CASH_FUND_COMPONENT_SCHEMA_URL,
  componentType: CASH_FUND_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: CashFundComponentAdd,
    dragComponentView: CashFundComponentGrabber,
    editComponentView: CashFundComponentEdit,
    createComponentView: CashFundComponentEdit,
  },
} as const;
